import axios from "../config/axios-chatbot";


export const VocabularyRepository = {
  getVocabulary: (flowUid) => axios.get(`/api/vocabulary?flow=${flowUid}`),
  getVocabularyByType: (flowUid, type = 'PRONUNCIATION') => axios.get(`/api/vocabulary?flow=${flowUid}&type=${type}`),
  create: (data) => axios.post(`/api/vocabulary`, data),
  update: (id, data) => axios.put(`/api/vocabulary/${id}`, data),
  delete: (id) => axios.delete(`/api/vocabulary/${id}`),
  getAudio: (text, flowUid) => axios.get(`/api/vocabulary/audio`, {params: {text, flow: flowUid}, responseType: 'blob'}),
  transcribe: (data) => axios.post(`/api/tts`, data),
  downloadAudio: ({endpoint, path}) => axios.get(endpoint || `/api/file/audio`, {params: {path: path}, responseType: 'blob'}),
  reloadPhonemizer: (flowUid) => axios.post(`/api/vocabulary/${flowUid}/reload`, {action: "clear_tts_cache"}),
}